import { DocumentNode } from "@apollo/client";
import gql from "graphql-tag";
import { PureQueryOptions } from "@apollo/client";
import { GraphQlQueryBuilder } from "./graphQl-query.builder";

export class MiUsuarioGraphQlBuilder {
  private get _query(): DocumentNode {
    return gql`
      query miUsuario {
        miUsuario {
          uuid
          nombre
          usuario
          apellidos
          zonaHoraria
          idioma
          mail
          rol
          lastLogin
          enabled
          dispositivos {
            uuid
            nombre
          }
        }
      }
    `;
  }

  public build(): PureQueryOptions {
    const graphQlBuilder: GraphQlQueryBuilder = new GraphQlQueryBuilder();
    return graphQlBuilder.withQuery(this._query).build();
  }
}
